<template>
	<!-- 招商合作 -->
	<div class="cooperation">
		<div class="callUS">
			<div class="textCenter f28 pt25">云当铺 </div>
			<div class="textGary f14">致力于打造一个安全可靠的闲置交易环境，给用户带来真正省心、快捷、美好的变现及购物体验</div>
			<div class="line"></div>
		</div>
		<div class="infor">
			<div class="list headerTitle" v-for="(item, index) in numberIndex" :key="index">
				<div class="name f14">{{item.titleName}}</div>
				<div class="num f20" v-if="index == 0">{{item.dec}}</div>
				<div class="num f20" v-else>{{item.dec.substring(0, item.dec.length - 2)}}
					<div class="size f12">{{item.dec.substring(item.dec.length - 2, item.dec.length)}}</div>
				</div>
			</div>
		</div>
		<div class="leaveUnused">
			<div class="textCenter f28 pt25">遇见 - 云当铺 </div>
			<div class="textCenter f26">开启寄售与回收的双重财富之门</div>
			<div class="contactsImage">
				<div class="input mb10">
					<div class="name f18 msg"><label style="color:red;">*</label>姓名：</div><el-input v-model="name"
						placeholder="请输入姓名" />
					<p class="errorMessage" v-if="nameMessage">{{ nameMessage }}</p>
				</div>
				<div class="input mb10">
					<div class="name f18 msg"><label style="color:red;">*</label>电话：</div><el-input type="number"
						v-model="phoneNumber" placeholder="请输入电话" />
					<p class="errorMessage" v-if="errorMessage">{{ errorMessage }}</p>
				</div>
				<!--  <div class="input">
                    <div class="name f18"><label>&nbsp;</label>微信：</div><el-input  v-model="wechat"  placeholder="请输入微信" clear />
                </div> -->
			</div>
			<el-button class="button" @click="showPopup" :loading="loading">提交合作</el-button>
		</div>
		<div class="pt80"></div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				loading: false,
				name: '',
				numberIndex: {},
				wechat: '',
				phoneNumber: '',
				errorMessage: '',
				nameMessage: '',
			};
		},
		async mounted() {
			await this.getIndexContent();
		},
		// 列表循环滚动结束
		methods: {
			async getIndexContent() {
				let type = this.$route.query.id;
				let res = await this.util.request({
					url: `/sy/website/getIndexContent/${type}`,
					method: 'GET',
					data: {}
				});
				if (res.status === 200) {
					this.numberIndex = res.data.numberIndex;
				} else {
					console.log(res.statusText);
				}
			},
			async showPopup() {
				if (!this.name) {
					this.nameMessage = '请输入姓名';
					return;
				} else {
					this.nameMessage = '';
				}
				const reg = /^1[3-9]\d{9}$/;
				if (!reg.test(this.phoneNumber)) {
					this.errorMessage = '请输入11位有效号码';
					return;
				} else {
					this.errorMessage = '';
				}

				this.loading = true
				let url = ''
				if (!this.wechat) {
					url = `/sy/website/submit/business/${this.name}/${this.phoneNumber}`
				} else {
					url = `/sy/website/submit/business/${this.name}/${this.phoneNumber}/${this.wechat}`
				}
				let res = await this.util.request({
					url: url,
					method: 'GET',
					data: {}
				});
				if (res.status === 200) {
					this.loading = false
					this.name = this.phoneNumber = this.wechat = ''
					this.$message({
						showClose: true,
						message: '已提交成功，稍后会有客服联系您！',
						type: 'success',
						duration: 5000
					});
				} else {
					this.loading = false
					this.$message({
						showClose: true,
						message: '提交失败，请联系客服！',
						type: 'error',
						duration: 5000
					});
					console.log(res.statusText)
				}
			},

		},
	}
</script>
<style>
	.contactsImage .el-input__inner {
		border: none;
		font-size: 18px;
	}
</style>


<style lang="less" scoped>
	//2024-02-28 start

	.line {
		width: 35px;
		height: 2.5px;
		background: #FF354A;
		margin: auto;
		margin-top: 10px;
	}

	// 2024-02-28 end
	.cooperation {
		.callUS {
			width: 100%;
			margin: auto;

			.textGary {
				text-align: center;
				color: #999;
				margin-top: 0.5rem;
			}
		}

		.leaveUnused {
			.textCenter {
				margin-top: 0.5rem;
				font-weight: bold;
			}

			.textGary-class {
				text-align: center;
				color: #999;
				margin-top: 0.5rem;
				margin-bottom: 30px;
			}

			img {
				margin-left: 5%;
				margin-top: 4rem;
				margin-bottom: 4rem;
			}

		}

		.infor {
			width: 60%;
			margin: auto;
			padding: 20px 0;
			display: flex;
			justify-content: space-around;
			background-color: #FF354A;
			margin-top: 35px;
			color: #fff;

			.list {
				padding: 8px 13px;
				min-width: 180px;
				text-align: center;
				display: flex;
				flex-direction: column;
				align-items: center;

				.num {
					font-style: oblique;
					color: #fff;
					display: flex;
					align-items: baseline;
					margin-top: 5px;
					font-weight: bold;
				}
			}
		}
	}

	.headerTitle {
		position: relative;
		color: #fff;
		display: flex;
		align-items: center;
		text-align: center;
	}

	.headerTitle:not(:first-child):before {
		content: '';
		width: 0.5px;
		height: 60px;
		background: #ffffff;
		position: absolute;
		left: -24px;
	}

	.headerTitle:last-child .line {
		display: none;
	}

	.button {
		display: flex;
		justify-content: center;
		color: #000;
		text-align: center;
		width: 200px;
		height: 40px;
		// line-height: 40px;
		margin: auto !important;
		border-radius: 50px;
		background-color: #E0E0E0;
		cursor: pointer;
	}

	.contactsImage {
		width: 450px;
		margin: auto;
		margin-top: 60px;
		margin-bottom: 40px;
		border-radius: 14px;
		padding: 15px;
		border: solid 1px #D8D8D8;

		.input {
			display: flex;
			border-bottom: solid 1px #D8D8D8;
			position: relative;

			.errorMessage {
				position: absolute;
				right: 10px;
				color: #FF354A;
				font-size: 12px;
			}
		}

		.name {
			width: 17%;
		}

	}

	.msg {
		height: 40px;
		line-height: 40px;
	}
</style>

<style lang="less">
	.indexButtom {
		background-color: #fff !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/cooperation.vue